/**
 * Een competentiegroep wordt ook wel een thema genoemd
 */

iScreenWizard.factory('Competentiegroep', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('competentiegroep', params).then(function (response) {
                var competentiegroepen = response.data;
                resolve(competentiegroepen);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('competentiegroep/'+id).then(function (response) {
                var competentiegroep = response.data;
                resolve(competentiegroep);
            }, reject);
        });
    };

    data.getLinkedCompetenties = function(competentiegroep) {
        return $q(function (resolve, reject) {
            params = {
                _method: 'get_gelinkte_competenties',
            };
            Ajax.get('competentiegroep/'+competentiegroep.id, params).then(function (response) {
                resolve(response.data.competentie_ids);
            }, reject);
        });
    };

    data.linkCompetenties = function(competentiegroep) {
        return $q(function (resolve, reject) {
            params = {
                _method: 'link_competenties',
                competentie_ids: competentiegroep.competentie_ids
            };
            Ajax.post('competentiegroep/'+competentiegroep.id, params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };

    return data;
});